import type { showAllAgentContactsProps } from "./_types";
import logEvent from "./logEvent";
import type { LoggingEvent } from './logEvent'


/**
 *
 * @param props This object contains
 */

const showAllAgentContacts = ({ state, target, result_id, subject_type, contact_type, contact_target }: showAllAgentContactsProps) => {
  // UA
  // Handled as a legacy event at the moment

  // Tag Manager
  let layerUpdate: LoggingEvent = { event: "show_all_agent_contacts" };

  if (contact_type) layerUpdate.contact_type = contact_type;
  if (state) layerUpdate.contact_state = state;
  if (target) layerUpdate.contact_target = target;
  if (result_id) layerUpdate.result_id = result_id;
  if (subject_type) layerUpdate.subject_type = subject_type;
  if (contact_target) layerUpdate.contact_target = contact_target;

  logEvent(layerUpdate);
};

export default showAllAgentContacts;
